import React from 'react';
import ticketIconImage from './icon-ticket.svg';
import './TicketIcon.css';

function TicketIcon() {
  return (
    <div className="ticket-icon-container">
      <img alt="Ticket Icon" src={ticketIconImage} />
    </div>
  );
}

export default TicketIcon;



// WEBPACK FOOTER //
// ./src/components/TicketIcon/index.js